export class RespinEvents {
	public static readonly RESPIN_STARTED: string = 'RespinEvents::__RESPIN_STARTED__';
	public static readonly RESPIN_REMOVING_FINISHED: string = 'RespinEvents::__RESPIN_REMOVING_FINISHED__';

	public static readonly LEAVING_SCATTER_AT: string = 'RespinEvents::__LEAVING_SCATTER_AT__';
	public static readonly LEAVING_SYMBOL_AT: string = 'RespinEvents::__LEAVING_SYMBOL_AT__';
	public static readonly END_ANIM_TRIGGERED: string = 'RespinEvents::__END_ANIM_TRIGGERED__';
}



// WEBPACK FOOTER //
// ./src/respin/RespinEvents.ts